/** Parse a server datetime. Values without a timezone are treated as UTC. */
export const parseServerDate = (value) => {
  if (value == null || value === '') return null;
  if (value instanceof Date) {
    return Number.isNaN(value.getTime()) ? null : value;
  }

  const raw = String(value).trim();
  if (!raw) return null;

  // Date-only values should not shift by timezone
  if (/^\d{4}-\d{2}-\d{2}$/.test(raw)) {
    const localDate = new Date(`${raw}T00:00:00`);
    return Number.isNaN(localDate.getTime()) ? null : localDate;
  }

  const hasTimezone = /[zZ]$/.test(raw) || /[+-]\d{2}:?\d{2}$/.test(raw);
  const parsed = new Date(hasTimezone ? raw : `${raw}Z`);
  return Number.isNaN(parsed.getTime()) ? null : parsed;
};

/** Format a server UTC datetime in the user's local timezone. */
export const formatLocalDateTime = (value, options) => {
  if (value == null || value === '') return '—';
  const date = parseServerDate(value);
  if (!date) return String(value);

  if (options) {
    return date.toLocaleString(undefined, options);
  }

  const raw = String(value).trim();
  if (/^\d{4}-\d{2}-\d{2}$/.test(raw)) {
    return date.toLocaleDateString(undefined, { dateStyle: 'medium' });
  }

  return date.toLocaleString(undefined, {
    dateStyle: 'medium',
    timeStyle: 'medium'
  });
};
